const QualityCertificationIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="75"
      viewBox="0 0 80 75"
      fill="none"
      {...props}
    >
      <path
        d="M40.4416 64.711C58.3587 64.711 72.8833 50.3106 72.8833 32.5469C72.8833 14.7832 58.3587 0.382812 40.4416 0.382812C22.5246 0.382812 8 14.7832 8 32.5469C8 50.3106 22.5246 64.711 40.4416 64.711Z"
        fill="#06AEB3"
      />
      <path
        d="M46.0801 60.8142C46.0801 60.4638 46.3666 60.1797 46.7201 60.1797H60.8001C61.1535 60.1797 61.4401 60.4638 61.4401 60.8142V72.6157C61.4401 73.1266 60.8621 73.428 60.4375 73.1386L54.1227 68.8343C53.9043 68.6854 53.6159 68.6854 53.3975 68.8343L47.0827 73.1386C46.658 73.428 46.0801 73.1266 46.0801 72.6157V60.8142Z"
        fill="white"
      />
      <path
        d="M4.3999 18.1748C4.3999 15.9684 6.19076 14.1797 8.3999 14.1797H71.5999C73.809 14.1797 75.5999 15.9684 75.5999 18.1748V60.5234C75.5999 62.7299 73.809 64.5186 71.5999 64.5186H8.3999C6.19076 64.5186 4.3999 62.7299 4.3999 60.5234V18.1748Z"
        fill="#027C80"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.5999 15.578H8.3999C6.96396 15.578 5.7999 16.7406 5.7999 18.1748V60.5234C5.7999 61.9576 6.96396 63.1203 8.3999 63.1203H71.5999C73.0358 63.1203 74.1999 61.9576 74.1999 60.5234V18.1748C74.1999 16.7406 73.0359 15.578 71.5999 15.578ZM8.3999 14.1797C6.19076 14.1797 4.3999 15.9684 4.3999 18.1748V60.5234C4.3999 62.7299 6.19076 64.5186 8.3999 64.5186H71.5999C73.809 64.5186 75.5999 62.7299 75.5999 60.5234V18.1748C75.5999 15.9684 73.809 14.1797 71.5999 14.1797H8.3999Z"
        fill="#004B4C"
      />
      <path
        d="M8.6001 20.5723C8.6001 19.3588 9.58507 18.375 10.8001 18.375H69.2001C70.4151 18.375 71.4001 19.3588 71.4001 20.5723V58.1268C71.4001 59.3403 70.4151 60.3241 69.2001 60.3241H10.8001C9.58507 60.3241 8.6001 59.3403 8.6001 58.1268V20.5723Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.2001 19.7733H10.8001C10.3583 19.7733 10.0001 20.131 10.0001 20.5723V58.1268C10.0001 58.568 10.3583 58.9258 10.8001 58.9258H69.2001C69.6419 58.9258 70.0001 58.568 70.0001 58.1268V20.5723C70.0001 20.131 69.6419 19.7733 69.2001 19.7733ZM10.8001 18.375C9.58507 18.375 8.6001 19.3588 8.6001 20.5723V58.1268C8.6001 59.3403 9.58507 60.3241 10.8001 60.3241H69.2001C70.4151 60.3241 71.4001 59.3403 71.4001 58.1268V20.5723C71.4001 19.3588 70.4151 18.375 69.2001 18.375H10.8001Z"
        fill="#004B4C"
      />
      <path
        d="M14 24.7676C14 23.5541 14.985 22.5703 16.2 22.5703H63.8C65.015 22.5703 66 23.5541 66 24.7676V29.3621C66 30.5756 65.015 31.5594 63.8 31.5594H16.2C14.985 31.5594 14 30.5756 14 29.3621V24.7676Z"
        fill="#FFD6BF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.8 23.9686H16.2C15.7582 23.9686 15.4 24.3264 15.4 24.7676V29.3621C15.4 29.8034 15.7582 30.1611 16.2 30.1611H63.8C64.2418 30.1611 64.6 29.8034 64.6 29.3621V24.7676C64.6 24.3264 64.2418 23.9686 63.8 23.9686ZM16.2 22.5703C14.985 22.5703 14 23.5541 14 24.7676V29.3621C14 30.5756 14.985 31.5594 16.2 31.5594H63.8C65.015 31.5594 66 30.5756 66 29.3621V24.7676C66 23.5541 65.015 22.5703 63.8 22.5703H16.2Z"
        fill="#004B4C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1001 39.457C14.1001 39.0708 14.4135 38.7578 14.8001 38.7578H20.3001C20.6867 38.7578 21.0001 39.0708 21.0001 39.457C21.0001 39.8431 20.6867 40.1561 20.3001 40.1561H14.8001C14.4135 40.1561 14.1001 39.8431 14.1001 39.457Z"
        fill="#027C80"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6997 39.5507C23.6997 39.1646 24.0131 38.8516 24.3997 38.8516H38.5997C38.9863 38.8516 39.2997 39.1646 39.2997 39.5507C39.2997 39.9368 38.9863 40.2499 38.5997 40.2499H24.3997C24.0131 40.2499 23.6997 39.9368 23.6997 39.5507Z"
        fill="#027C80"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1001 45.5429C14.1001 45.1568 14.4135 44.8438 14.8001 44.8438H34.6001C34.9867 44.8438 35.3001 45.1568 35.3001 45.5429C35.3001 45.929 34.9867 46.2421 34.6001 46.2421H14.8001C14.4135 46.2421 14.1001 45.929 14.1001 45.5429Z"
        fill="#027C80"
      />
      <path
        d="M46.3999 56.5312C46.3999 56.5312 49.9999 59.6275 53.7999 59.6275C57.5999 59.6275 61.1999 56.5312 61.1999 56.5312V73.1111L53.7999 67.9174L46.3999 73.1111V56.5312Z"
        fill="#FFD6BF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.7999 57.5503C60.6691 56.9878 61.1999 56.5312 61.1999 56.5312V73.1111L53.7999 67.9174L46.3999 73.1111V56.5312C46.3999 56.5312 46.9307 56.9878 47.7999 57.5503C49.1942 58.4526 51.4591 59.6275 53.7999 59.6275C56.1407 59.6275 58.4056 58.4526 59.7999 57.5503ZM59.7999 59.1904C59.7383 59.226 59.6758 59.2618 59.6123 59.2975C58.1505 60.1204 56.0507 61.0258 53.7999 61.0258C51.5491 61.0258 49.4493 60.1204 47.9875 59.2975C47.924 59.2618 47.8615 59.226 47.7999 59.1904V70.4195L53.7999 66.2084L59.7999 70.4195V59.1904Z"
        fill="#004B4C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1001 51.5351C14.1001 51.149 14.4135 50.8359 14.8001 50.8359H34.6001C34.9867 50.8359 35.3001 51.149 35.3001 51.5351C35.3001 51.9212 34.9867 52.2342 34.6001 52.2342H14.8001C14.4135 52.2342 14.1001 51.9212 14.1001 51.5351Z"
        fill="#027C80"
      />
      <path
        d="M67.8003 49.1393C67.8003 56.8619 61.5323 63.1223 53.8003 63.1223C46.0683 63.1223 39.8003 56.8619 39.8003 49.1393C39.8003 41.4167 46.0683 35.1562 53.8003 35.1562C61.5323 35.1562 67.8003 41.4167 67.8003 49.1393Z"
        fill="#FFA473"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.8003 61.724C60.7591 61.724 66.4003 56.0896 66.4003 49.1393C66.4003 42.1889 60.7591 36.5546 53.8003 36.5546C46.8415 36.5546 41.2003 42.1889 41.2003 49.1393C41.2003 56.0896 46.8415 61.724 53.8003 61.724ZM53.8003 63.1223C61.5323 63.1223 67.8003 56.8619 67.8003 49.1393C67.8003 41.4167 61.5323 35.1562 53.8003 35.1562C46.0683 35.1562 39.8003 41.4167 39.8003 49.1393C39.8003 56.8619 46.0683 63.1223 53.8003 63.1223Z"
        fill="#004B4C"
      />
      <path
        d="M64.0001 49.1408C64.0001 54.7672 59.4334 59.3284 53.8001 59.3284C48.1668 59.3284 43.6001 54.7672 43.6001 49.1408C43.6001 43.5143 48.1668 38.9531 53.8001 38.9531C59.4334 38.9531 64.0001 43.5143 64.0001 49.1408Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.8001 57.9301C58.6602 57.9301 62.6001 53.995 62.6001 49.1408C62.6001 44.2865 58.6602 40.3514 53.8001 40.3514C48.94 40.3514 45.0001 44.2865 45.0001 49.1408C45.0001 53.995 48.94 57.9301 53.8001 57.9301ZM53.8001 59.3284C59.4334 59.3284 64.0001 54.7672 64.0001 49.1408C64.0001 43.5143 59.4334 38.9531 53.8001 38.9531C48.1668 38.9531 43.6001 43.5143 43.6001 49.1408C43.6001 54.7672 48.1668 59.3284 53.8001 59.3284Z"
        fill="#004B4C"
      />
      <path
        d="M53.2906 43.5618C53.5254 43.1847 54.0749 43.1847 54.3097 43.5618L55.8156 45.9809C55.8982 46.1135 56.0294 46.2088 56.1813 46.2462L58.9501 46.9291C59.3817 47.0356 59.5515 47.5576 59.265 47.8972L57.4269 50.0751C57.326 50.1946 57.2759 50.3487 57.2872 50.5045L57.4925 53.3456C57.5245 53.7885 57.0799 54.1112 56.6681 53.9439L54.0262 52.8709C53.8813 52.812 53.7191 52.812 53.5742 52.8709L50.9323 53.9439C50.5204 54.1112 50.0758 53.7885 50.1078 53.3456L50.3131 50.5045C50.3244 50.3487 50.2743 50.1946 50.1735 50.0751L48.3354 47.8972C48.0488 47.5576 48.2186 47.0356 48.6503 46.9291L51.4191 46.2462C51.5709 46.2088 51.7022 46.1135 51.7848 45.9809L53.2906 43.5618Z"
        fill="#FF5A01"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.7811 43.2454C53.2506 42.4911 54.3497 42.4911 54.8192 43.2454L56.3251 45.6644L59.0939 46.3473C59.9572 46.5603 60.2969 47.6043 59.7237 48.2834L57.8856 50.4614L58.091 53.3025C58.155 54.1883 57.2658 54.8336 56.442 54.499L53.8002 53.426L51.1583 54.499C50.3345 54.8336 49.4454 54.1883 49.5094 53.3025L49.7147 50.4614L47.8766 48.2834C47.3035 47.6043 47.6431 46.5603 48.5064 46.3473L51.2752 45.6644L52.7811 43.2454ZM55.306 46.2973L53.8002 43.8782L52.2943 46.2973C52.1291 46.5627 51.8666 46.7531 51.5629 46.828L48.7941 47.5109L50.6322 49.6889C50.8339 49.9278 50.9341 50.236 50.9116 50.5476L50.7063 53.3888L53.3481 52.3158C53.638 52.198 53.9624 52.198 54.2522 52.3158L56.8941 53.3888L56.6887 50.5476C56.6662 50.236 56.7665 49.9278 56.9681 49.6889L58.8062 47.5109L56.0374 46.828C55.7337 46.7531 55.4712 46.5627 55.306 46.2973Z"
        fill="#004B4C"
      />
    </svg>
  );
};

export default QualityCertificationIcon;
